/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import { FRAuth, FRStep, StepType } from '@forgerock/javascript-sdk';

import {FormContainer, TextFieldElement} from 'react-hook-form-mui';
import { useForm } from 'react-hook-form';

import { Button } from '@mui/material';
import { useRef, useState, useEffect } from 'react';
import SuccessErrorModal from '../../modals/SuccessErrorModal';
import FormLayout from '../../layout/form';
import FormSection from '../../01-atoms/FormSection';
import Row from '../../01-atoms/Row';
import { useNavigate } from 'react-router-dom';
import { BaseCallBackInterface } from '../common/basInterface';
import { is } from 'immer/dist/internal';
import isEmpty from 'lodash/isEmpty';
// import { isEmpty } from 'lodash';
import CustomFormContainer from '../../layout/CustomFormContainer';
import loginStyles from '../../../styles/Login.module.css';
import classnames from 'classnames';
import { appInsights } from '../../../appInsights/appInsights';
import { configOptions } from '../../../config/index';

interface loginCallBackInterface extends BaseCallBackInterface{
  goto:string
}

export default function LoginForm ({ step, setStep,messageType,setMessageType,message,setMessage,tree,isAlertOpen,setIsAlertOpen, goto }: loginCallBackInterface) {
  
  const formContext = useForm<{}>({
    defaultValues: {
    }
  });

  //  used for the modal. depreciated
  const [isDisabled,setDisabled] = useState(false);
  const navigate = useNavigate();


  //  ---------------------METHODS-----------------------------------


      const [passwordMasked, setPasswordMasked] = useState(true);
      const [passwordFocused, setPasswordFocused] = useState(false);
      const [passwordEmpty, setPasswordEmpty] = useState(true);
      const [emailInvalid, setEmailInvalid] = useState(true);
      const [validateForm, setValidateForm] = useState(false);
      // const [TARGET, setTARGET] = useState(process.env.REACT_APP_TARGET),
      // const [SMAGENTNAME, setSMAGENTNAME] = useState(process.env.REACT_APP_SMAGENTNAME),

//should be converted to userefs()
    const emailInputRef = useRef<HTMLInputElement>(null);
    const passwordInputRef = useRef<HTMLInputElement>(null);
    const formRef = useRef<HTMLFormElement>(null);


  
    useEffect(() => {
      let errorCode:string
      if(isAlertOpen === false){
        appInsights.trackPageView({name: 'Login Landing'});
      } else{
        errorCode = errorCodesInsights( message )
          appInsights.trackEvent({
            name: 'Login Return',
            properties: {
              origin: errorCode
            }
          });
          appInsights.flush()
      }
    },[message,isAlertOpen]);
  
  function errorCodesInsights(message:string){
    let errorCode = ""
    if(!!(message.match(/The email or password.*Please try again/gi)) || !!(message.match(/You have 1 more try remaining.* reset your password/gi))){
      errorCode = "Invalid Credentials"
    } else if(!!(message.match(/Your password has expired.*continue/gi))){
      errorCode = "Password Expired"
    }else if(!!(message.match(/Your account is locked.*to reset your password/gi))){
      errorCode = "Login Error Too Many Attempts"
    }else if(!!(message.match(/Your.*PW focal/gi))){
      errorCode = "Login Error Inactive User"
    } else{
      errorCode ="Login Error Other"
    }
    return errorCode
  }
  
  function togglePassword(this: any) {
    setPasswordMasked(!passwordMasked);
    passwordInputRef.current?.focus();
    // passwordInputRef?.current.setSelectionRange(0, 5);
  }

  function toggleFocus(evt: any) {
    // if (document.activeElement !== passwordInputRef) {
      setPasswordFocused(false);
    // }
  }

  function isEmptyValue(event: any) {
    setPasswordEmpty( !event.target.value.length);
  }

  function isEmailInvalid(event: { target: { value: string; }; }) {
    setEmailInvalid(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(event.target.value.trim()));
    return emailInvalid;
  }

  function isValidEmail(val: string | undefined) {
    if(val != null){
      return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val.trim());
    } else{
      return false
    }
  }

  function isValidPassword(val: string | undefined) {
    return !!val?.length;
  }

  useEffect(()=>{
    setEmailInvalid(!emailInputRef.current?.value)
    setPasswordEmpty(!passwordInputRef.current?.value)
  //   this.setState((oldState) => {
  //     return {
  //       setEmailInvalid(!emailInputRef.current?.value)
  //   setPasswordEmpty(!passwordInputRef.current?.value)
  // }
  //   if (this.props.location.search) {
  //   let s = this.props.location.search.substr(1).split('&');
  //   let SMAGENTNAME = s.find((item) => item.split('=')[0] === 'SMAGENTNAME');
  //   if (SMAGENTNAME) {
  //     SMAGENTNAME = decodeURIComponent(SMAGENTNAME.split('=')[1]);
  //     this.setState({
  //       SMAGENTNAME: SMAGENTNAME,
  //     });
  //   }
  //   let TARGET = s.find((item) => item.split('=')[0] === 'TARGET');
  //   if (TARGET) {
  //     TARGET = decodeURIComponent(TARGET.split('=')[1]);
  //     this.setState({
  //       TARGET: TARGET
  //     });
  //   }
  },[])

  // document.addEventListener('click', this.toggleFocus);
  //   if (this.props.maintenance) {
  //     appInsights.trackPageView({name: 'Login Landing - Maintenance'});
  //   } else {
  //     appInsights.trackPageView({name: 'Login Landing'});
  //   }

  useEffect(() => {
    return () => {
      document.removeEventListener('click', toggleFocus)
    }
  });



  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function fillStep(step: FRStep, data: any): void {
    const fillStep = step;
    fillStep.callbacks[0].setInputValue(data.username);
    fillStep.callbacks[1].setInputValue(data.password);
    setStep(fillStep);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSuccess = async (event: any) => {
      event?.preventDefault();
      console.log(emailInvalid, passwordEmpty);
      let data = { username: "", password: "" };
      if (!!emailInputRef.current?.value && !!passwordInputRef.current?.value) {
        data.username = emailInputRef.current?.value;
        data.password = passwordInputRef.current?.value;
      }
      setDisabled(true);
      handleClose();
      if(!emailInvalid && !passwordEmpty){
        fillStep(step as FRStep, data);
        let nextStep = await FRAuth.next(step as FRStep);
        setStep(nextStep);
      }
      setTimeout(() => {
        setDisabled(false);
      }, 0);
      setValidateForm(true);
      setPasswordEmpty(!isValidPassword(passwordInputRef.current?.value));
      setEmailInvalid(!isValidEmail(emailInputRef.current?.value));
  };

  const handleOpen = () => {
    setIsAlertOpen(true);
  };
  const handleClose = () => {
  
    setIsAlertOpen(false);
  };

  //  -----------------END METHODS-----------------------------------

  return (
    <>
      {!isAlertOpen ? (
        <>
          {/* <SuccessErrorModal
        open={isAlertOpen}
        type={messageType}
        handleClose={handleClose}
        message={message}
      /> */}
          
          <a href={configOptions.lifeRayURL} onClick={(e)=>{
                  e.preventDefault()
                }} ><div className={loginStyles.logoWrapper}></div></a>
          <div className={loginStyles.headerTitle}>
          EngineWise® Connect Login
          </div>

          <form ref={formRef} style={{marginBottom:"170px"}}>
            {/* email section */}
            <section className={loginStyles.emailSection}>
              <label
                htmlFor="emailInput"
                className={loginStyles.emailPasswordLable}
              >
                Email
              </label>
              <input
                type="text"
                name="USER"
                id="emailInput"
                autoComplete="off"
                ref={emailInputRef}
                onChange={isEmailInvalid}
                // disabled={ this.props.maintenance.loginDisabled }
                disabled={true}
                className={classnames(`${loginStyles.emailInput}`, {
                  [loginStyles.invalid]: validateForm && emailInvalid,
                })}
              />
              {validateForm && emailInvalid && (
                <span
                  className={`${loginStyles.invalidMarker} ${loginStyles.invalidMarkerText}`}
                ></span>
                // <span className={loginStyles.invalidMarker}></span>
              )}
            </section>

            {/* password section */}
            <section className={loginStyles.passwordSection}>
              <label
                htmlFor="passwordInput"
                className={loginStyles.emailPasswordLable}
              >
                Password
              </label>
              <input
                type={passwordMasked ? "password" : "text"}
                name="PASSWORD"
                id="passwordInput"
                autoComplete="off"
                ref={passwordInputRef}
                // onPaste={(e)=>{
                //   e.preventDefault();
                //   return false;
                // }}
                onChange={isEmptyValue}
                disabled={true}
                // disabled={ this.props.maintenance.loginDisabled }
                className={classnames(`${loginStyles.passwordInput}`, {
                  [loginStyles.focused]: passwordFocused && validateForm && passwordEmpty,
                  [loginStyles.empty]: passwordEmpty,
                  [loginStyles.invalid]: validateForm && passwordEmpty,
                })}
              />
              <span
                className={classnames({
                  [loginStyles.togglePassword]: !passwordEmpty,
                  [loginStyles.visible]: passwordMasked,
                })}
                onClick={togglePassword}
                onMouseDown={() => {
                  setPasswordFocused(true);
                }}
              ></span>
              {validateForm && passwordEmpty && (
                <span
                  className={`${loginStyles.invalidMarker} ${loginStyles.invalidMarkerText}`}
                ></span>
              )}
            </section>
            <section className={loginStyles.loginbuttonlinks}>
              <button
                onClick={(e)=>{
                  e.preventDefault()
                }}
                className={loginStyles.loginButton}
                
                // disabled={ this.props.maintenance.loginDisabled }
              >
                <div className={loginStyles.loginButtonText}>Log In</div>
              </button>
              <a 
                rel="noopener noreferrer" 
                className={loginStyles.employeeLogin}
                
                onClick={(e)=>{
                  e.preventDefault()
                }}
                >
                Employee Login
              </a>
              <a
                rel="noopener noreferrer"
                className={loginStyles.forgotpassword}
                onClick={(e)=>{
                  e.preventDefault()
                }}
              >
                Forgot Password
              </a>
              
            </section>

            <section className={loginStyles.terms}>
              <span className={loginStyles.termsText}>
                By logging into this website I understand the obligations for
                using this portal and accept the Pratt &amp; Whitney&nbsp;
                <a href="http://links.pw.utc.com/body/html/terms.html" target="_blank" rel="noopener noreferrer" onClick={(e)=>{
                  e.preventDefault()
                }}>
                  Terms and Conditions
                </a>
                .
              </span>
            </section>

          <section className={loginStyles.additionalLinks}>
            
            <section className={loginStyles.paddingandMargin}>  
              <a className={ loginStyles.createAccountLink } 
              onClick={(e)=>{
                e.preventDefault()
              }}
              >Create Account</a>
            </section>
            <section className={loginStyles.paddingandMargin}> 
              <a className={ loginStyles.loginHelp } 
             onClick={(e)=>{
              e.preventDefault()
            }}
              >Login Help</a>
            </section >
            <section className={loginStyles.paddingandMargin}> 
              <a href="https://pwportal.prattwhitney.com/" onClick={(e)=>{
                  e.preventDefault()
                }} target="_blank" rel="noopener noreferrer" className={ loginStyles.supplierPortal }>Supplier Portal</a>
            </section>

          </section>

          
          
          <footer className={loginStyles.wrapper}>
            <section className={loginStyles.iaeLogo}></section>
            <section className={loginStyles.footerDivider}></section>
            <section className={loginStyles.links}>
              {/* <a  
                className={loginStyles.footerLinks}
                href="https://www.rtx.com/Privacy"
                target="_blank"
              >
                Privacy Statement
              </a>
              <a
                className={loginStyles.footerLinks}
                href="https://links.prattwhitney.com/body/html/terms.html"
                target="_blank"
              >
                Website Agreement
              </a>
              <a
                className={loginStyles.footerLinks}
                href="mailto:portalidentity@prattwhitney.com"
                target="_blank"
              >
                Contact Us
              </a>
              <a className={loginStyles.footerLinks}>Help Desk (860) 565-3550</a> */}

              <a href="https://prattwhitney.com" className={loginStyles.footerLinks} target="_blank" rel="noopener noreferrer" onClick={(e)=>{
                e.preventDefault()
              }}>Pratt &amp; Whitney</a>
        
              <a href="https://connect.prattwhitney.com" className={loginStyles.footerLinks} onClick={(e)=>{
                e.preventDefault()
              }} target="_blank" rel="noopener noreferrer">EngineWise®</a>

              <a href="http://links.pw.utc.com/body/html/terms.html" className={loginStyles.footerLinks}  onClick={(e)=>{
                e.preventDefault()
              }} target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
              
              <a href="http://www.rtx.com/Privacy" className={loginStyles.footerLinks} onClick={(e)=>{
                e.preventDefault()
              }} target="_blank" rel="noopener noreferrer">Privacy Notice</a>
              
              <a href="http://links.pw.utc.com/body/html/websiteagreement.html" onClick={(e)=>{
                e.preventDefault()
              }} className={loginStyles.footerLinks} target="_blank" rel="noopener noreferrer">Web Usage Statement</a>
              
            </section>
          </footer>
          </form>
        </>
      ) : (

        <>
          <a href={configOptions.lifeRayURL}><div className={loginStyles.logoWrapper}></div></a>
          {/* <div className={loginStyles.logoWrapper}></div> */}
          <div className={loginStyles.headerTitleError}>Authentication failed</div>
          <div className={loginStyles.loginFailuretext}>
            {/* Invalid email address or password. Please re-enter your credentials
            and try logging in again. */}
            {message}
          </div>
          <div style={{marginBottom:"170px"}}>
          <button className={loginStyles.returnToLogin}
            onClick={
              () => {
                // if (isEmpty(goto)) {
                //   navigate("/login");
                //   // navigate(-1);
                // } else {
                //   navigate("/login?goto=" + goto);
                // }
                handleClose();
              }

              // handleLoginRedirection
            }
          >
            <div className={loginStyles.backToLoginText}> 
              <div className={loginStyles.backToLoginTextvalue}>
                <b >
                  {"<-"}
                </b>
              </div>
              <div className={loginStyles.backToLoginTextvalue}>  
              {"Return to Login Page"}
              </div>
            </div>
          </button>
          <footer className={loginStyles.wrapperfailure}>
            <section className={loginStyles.iaeLogo}></section>
            <section className={loginStyles.footerDivider}></section>
            <section className={loginStyles.links}>
              {/* <a  
                className={loginStyles.footerLinks}
                href="https://www.rtx.com/Privacy"
                target="_blank"
              >
                Privacy Statement
              </a>
              <a
                className={loginStyles.footerLinks}
                href="https://links.prattwhitney.com/body/html/terms.html"
                target="_blank"
              >
                Website Agreement
              </a>
              <a
                className={loginStyles.footerLinks}
                href="mailto:portalidentity@prattwhitney.com"
                target="_blank"
              >
                Contact Us
              </a>
              <a className={loginStyles.footerLinks}>Help Desk (860) 565-3550</a> */}

              <a href="https://prattwhitney.com" className={loginStyles.footerLinks} target="_blank" rel="noopener noreferrer" onClick={(e)=>{
                e.preventDefault()
              }}>Pratt &amp; Whitney</a>
        
              <a href="https://connect.prattwhitney.com" className={loginStyles.footerLinks} onClick={(e)=>{
                e.preventDefault()
              }} target="_blank" rel="noopener noreferrer">EngineWise®</a>

              <a href="http://links.pw.utc.com/body/html/terms.html" className={loginStyles.footerLinks}  onClick={(e)=>{
                e.preventDefault()
              }} target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
              
              <a href="http://www.rtx.com/Privacy" className={loginStyles.footerLinks} onClick={(e)=>{
                e.preventDefault()
              }} target="_blank" rel="noopener noreferrer">Privacy Notice</a>
              
              <a href="http://links.pw.utc.com/body/html/websiteagreement.html" onClick={(e)=>{
                e.preventDefault()
              }} className={loginStyles.footerLinks} target="_blank" rel="noopener noreferrer">Web Usage Statement</a>
              
            </section>
          </footer>
          </div>

          
        </>
      )}
    </>
  );
}
